import NextLink from "next/link";
import { Link, Text } from "@cruk/cruk-react-components";
import { useTracking } from "@fwa/src/hooks/useTracking";
import { isPast } from "@fwa/src/utils/timeUtils";

import { MemberTeam } from "@fwa/src/components/MemberTeam";

import styles from "@fwa/src/components/MemberTeamJoin/styles.module.css";

import { type TeamPageType } from "@fwa/src/types";

export function MemberTeamJoin({ teamPage }: { teamPage: TeamPageType }) {
  const teamSlug = teamPage.url.replace(/https?:\/\/[^/]*/, "").split("?")[0];
  const { trackEventGtm } = useTracking();

  if (!teamPage) return null;

  return (
    <MemberTeam teamPage={teamPage}>
      <div className={styles["responsive-align"]}>
        {teamPage.closeDate && isPast(new Date(teamPage.closeDate)) ? (
          <Text style={{ lineHeight: "2.5rem" }} textAlign="center">
            Team Closed
          </Text>
        ) : (
          <NextLink
            href={`${teamSlug}/join`}
            aria-label={`Join ${teamPage.title}`}
            onClick={() => {
              trackEventGtm({
                event: "join_member_team_cta",
              });
            }}
            data-cta-type="join-super-team"
          >
            <Link appearance="secondary" as="span">
              Join team
            </Link>
          </NextLink>
        )}
      </div>
    </MemberTeam>
  );
}

export default MemberTeamJoin;
